import BackButton from "app/components/BackButton/BackButton";
import SegmentedControl from "app/components/SegmentedControl/SegmentedControl";
import { ResponsiveScreenSizes } from "app/utils/const";
import { Component } from "react";
import Media from "react-media";
import "./ManageFundingLogoHeader.scss";
//
type Props = {
  getTabs: any;
  history: any;
  logo: any;
  paymentMethod: string;
};
// TabTypes
export const TabTypes = {
  DEPOSIT: "DEPOSIT",
  WITHDRAW: "WITHDRAW",
};

class ManageFundingLogoHeader extends Component<Props> {
  render() {
    const { history, getTabs, logo, paymentMethod } = this.props;

    return (
      <>
        <Media
          query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
          render={() => (
            <div className="manage-funding-logo-header">
              <div className="manage-funding-logo-header__title">
                <BackButton history={history} mobile={true} />
                <div className="title__logo">{logo}</div>
                <div className="manage-funding-logo-header__spacer" />
              </div>
              <div className={`title__tabs ${paymentMethod?.toLowerCase()}`}>
                <SegmentedControl tabs={getTabs} tabTypes={TabTypes} />
              </div>
            </div>
          )}
        />
        <Media
          query={`(min-width: ${ResponsiveScreenSizes.desktop})`}
          render={() => (
            <div className="manage-funding-logo-header">
              <div className="manage-funding-logo-header__title">
                <div className="title__top">
                  <BackButton className="title__top__back" history={history} />
                  <div className="title__top__logo">{logo}</div>
                  <div className="manage-funding-logo-header__spacer" />
                </div>

                <div
                  className={`title__tabs ${paymentMethod?.toLowerCase()}_tab`}
                >
                  <SegmentedControl tabs={getTabs} tabTypes={TabTypes} />
                </div>
              </div>
            </div>
          )}
        />
      </>
    );
  }
}

export default ManageFundingLogoHeader;
